import { forwardRef } from 'react';
import type { Ref } from 'react';
import clsx from 'clsx';
import type { IconProps } from './Icon.types';
import { Link } from '../Link/Link';

export const Icon = forwardRef<HTMLAnchorElement | null, IconProps>(
  (
    {
      iconClass,
      ariaLabel,
      iconHref,
      trackingProperties,
      children,
      target,
      rel,
      custom_click_track_value,
      ariaLive,
      enableLinkClsName = false,
      isDecorative = false,
    },
    ref: Ref<HTMLAnchorElement | null>
  ) => {
    return iconHref ? (
      <Link
        linkHref={iconHref}
        text=""
        ariaLabel={ariaLabel}
        linkClassName={enableLinkClsName ? iconClass || '' : ''}
        trackingProperties={trackingProperties || {}}
        target={target}
        rel={rel}
        custom_click_track_value={custom_click_track_value}
        ref={ref as Ref<HTMLAnchorElement>}
      >
        <span
          data-component-name="a-ui-library-Icon"
          data-testid="ui-library-Icon"
          className={clsx(!enableLinkClsName ? iconClass : '')}
          aria-hidden="true"
        />
        {children}
      </Link>
    ) : (
      <span
        data-component-name="a-ui-library-Icon"
        data-testid="ui-library-Icon"
        aria-label={isDecorative ? undefined : ariaLabel}
        aria-live={isDecorative ? undefined : ariaLive}
        aria-atomic={isDecorative ? undefined : 'true'}
        aria-hidden={isDecorative ? true : undefined}
        className={clsx(iconClass)}
        custom_click_track_value={custom_click_track_value}
        role={isDecorative ? undefined : 'status'}
      >
        {children}
      </span>
    );
  }
);
